import DropdownMenu from "components/dropdownMenu";
import React from "react";
import { translate } from "reducers/i18n";
import { FiDownload } from "react-icons/fi";

export const DownloadAll = ({ triggerModal,downloadZip }) => {
  return (
    <DropdownMenu
      portal
      dropdownClassName="dropdown-container border-top"
      className="mr-auto"
      buttonClassName="bg-white text-black button d-block"
      svgClassName="d-none"
      buttonChildren={
        <span tabIndex="0" className="button p-1 border-rounded">
          <FiDownload /> {translate("message_download_all")}
        </span>
      }
      closeOnClick
    >
      {[
        { val: "all", translation: "message_download_separately", handleClick: triggerModal },
        { val: "zip", translation: "message_download_zip", handleClick: downloadZip },
      ].map((btn, i) => {
        return (
          <li
            key={i}
            tabIndex="0"
            className="dropdownMenu-list"
            style={{ transition: "all .3s" }}
            title=""
            onClick={btn.handleClick}
            onMouseOver={(e) => {
              e.stopPropagation();
              e.target.style.background = "#f2f2f2";
            }}
            onMouseLeave={(e) => {
              e.stopPropagation();
              e.target.style.background = "#fff";
            }}
          >
            <FiDownload /> {translate(btn.translation)}
          </li>
        );
      })}
    </DropdownMenu>
  );
};
